
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/invite/canvas/[key]/[invite]",
      function () {
        return require("private-next-pages/invite/canvas/[key]/[invite].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/invite/canvas/[key]/[invite]"])
      });
    }
  